<script setup lang="ts">
import { RouterView } from 'vue-router';

import { useUserStore } from '@/entities/user';

import { useAppInitialLoading } from './app-initial-loading';
import { useAppSeo } from './app-seo';
import { AppLoadingScreen, AuthenticatedLayout, CookieConsentBanner } from './index';

const userStore = useUserStore();
useAppSeo();
const { isInitialLoadingVisible } = useAppInitialLoading(() => userStore.isFetched);
</script>

<template>
  <AppLoadingScreen v-if="isInitialLoadingVisible" />

  <AuthenticatedLayout v-else-if="userStore.isFetched && userStore.isAuth">
    <RouterView />
  </AuthenticatedLayout>

  <RouterView v-else-if="userStore.isFetched" />

  <CookieConsentBanner />
</template>
